export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 民宿用户
    getBnbUserList: function getBnbUserList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/bnb/get",
        method: "get",
        params: data
      });
    },
    // 民宿充值
    bnbAccountCharge: function bnbAccountCharge() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/bnb_account/charge",
        method: "post",
        data: data
      });
    },
    // 更新用户信息
    updateBnbUserInfo: function updateBnbUserInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/bnb_account/updateUserInfo",
        method: "post",
        data: data
      });
    },
    // 民宿认证审核
    bnbAuth: function bnbAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/bnb/auth",
        method: "post",
        data: data
      });
    },
    // 民宿退款
    bnbAccountRefund: function bnbAccountRefund() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/bnb_account/refund",
        method: "post",
        data: data
      });
    },
    // 民宿公寓
    getBnbHouseList: function getBnbHouseList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/bnb/houseList",
        method: "get",
        params: data
      });
    },
    // 账户详情
    getBnbAccountDetail: function getBnbAccountDetail() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/bnb_account/statistics",
        method: "get",
        params: data
      });
    },
    // 结算记录
    getBnbSettlementList: function getBnbSettlementList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/bnb_account/getBill",
        method: "get",
        params: data
      });
    },
    // 资金记录
    getBnbMoneyList: function getBnbMoneyList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/bnb_account/chargeRecord",
        method: "get",
        params: data
      });
    },
    // 收入统计
    getBnbIncomeList: function getBnbIncomeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/bnb_account/all",
        method: "get",
        params: data
      });
    }
  };
});